module.exports = __webpack_public_path__ + "img/check.dd22d903.svg";